// The element -> wrapper map, in its own module so that date-picker.js can answer
// getDateTimePicker() synchronously WITHOUT pulling in date-picker-impl.js - and with it
// tempus-dominus - just to reach the WeakMap. Putting the map in the impl module would undo
// the whole point of the split.
const instances = new WeakMap();

export function registerPicker(element, wrapper) {
    instances.set(element, wrapper);
}

export function lookupPicker(element) {
    return instances.get(element) || null;
}

export function forgetPicker(element) {
    instances.delete(element);
}
